module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "user-group-selection-container"
  }, [(_vm.selectedGroupsCount > 0) ? _c('p', [_vm._v("\n      " + _vm._s(_vm.$tc('marker.selected_user_groups_count',
    _vm.selectedGroupsCount >= 2 ? 2 : 1, {
      count: _vm.selectedGroupsCount
    })) + "\n      "), _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleShowSelection($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('marker.user_group_click_here')))]), _vm._v("\n        " + _vm._s(_vm.$t('marker.user_group_to_change_selection')) + "\n      ")])]) : _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('marker.all_users_will_be_notified')) + "\n      "), _c('span', [_vm._v("\n        " + _vm._s(_vm.$t('marker.user_group_you_may')) + "\n        "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleShowSelection($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('marker.user_group_specify')))]), _vm._v("\n        " + _vm._s(_vm.$t('marker.user_group_which_groups_to_target')) + "\n      ")])]), _vm._v(" "), (_vm.showSelection) ? _c('div', {
    staticClass: "user-group-selection",
    style: ({
      top: _vm.tooltipPosition.y + 'px',
      left: _vm.tooltipPosition.x + 'px'
    })
  }, [_c('div', {
    staticClass: "user-group-selection-header"
  }, [_c('div', [_vm._v("\n          " + _vm._s(_vm.$t('marker.user_group_categories')) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.$t('marker.user_groups')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "user-group-selection-content"
  }, [_c('ul', {
    staticClass: "user-group-category"
  }, _vm._l((_vm.groups), function(category) {
    return _c('li', {
      class: {
        'selected': _vm.shownCategory === category.slug
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showCategory = category.slug
        }
      }
    }, [_vm._v("\n            " + _vm._s(category.name) + " "), _c('span', {
      staticClass: "glyphicon glyphicon-chevron-right"
    })])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "user-group"
  }, [_vm._l((_vm.groups), function(category) {
    return _vm._l((category.groups), function(group) {
      return _c('li', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (category.slug === _vm.shownCategory),
          expression: "category.slug === shownCategory"
        }],
        class: {
          'selected': _vm.isSelected(category, group)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toggle(category, group)
          }
        }
      }, [_vm._v("\n            " + _vm._s(group.name) + "\n            "), _c('span', {
        staticClass: "glyphicon glyphicon-ok-circle"
      })])
    })
  })], 2)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39db3cf5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markerEdit/SelectGroups.vue
// module id = 1033
// module chunks = 1